var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.643 6.985C1.093 11.534 0 26.472 0 26.472s3.102-1.614 8.066-2.025c4.698-.411 9.011-1.057 11.552-3.58 3.93-3.904 4.905-9.421 2.66-13.354-2.453 3.815-12.528 9.274-12.528 9.274C16.989 11.651 20.682 7.66 25.645.646L23.223 0s-1.802 3.258-3.398 4.813c-3.96-2.788-9.986-1.966-14.182 2.172z",
    fill: "#399829",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.de888e8e.svg";
export { ForwardRef as ReactComponent };